import { render, staticRenderFns } from "./CreateEditNote.vue?vue&type=template&id=38061f44&"
import script from "./CreateEditNote.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateEditNote.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports